import { IWidgetVersionRestClient } from "./i-widget-version-rest.client";
import { HttpClient } from "@angular/common/http";
import { HostUtil } from "../../../utils/host-util";
import { firstValueFrom, Observable } from "rxjs";
import { ARestClient, IPage, ISort } from "@zaeper/communication-lib";
import { Injectable } from "@angular/core";
import { IWidgetVersion } from "../../../models/application-version/i-widget-version";
import { IGetWidgetVersionPageForm } from "./forms/i-get-widget-version-page.form";

@Injectable()
export class WidgetVersionRestClient extends ARestClient implements IWidgetVersionRestClient {
  constructor( private readonly _httpClient: HttpClient ) {
    super();
  }

  getWidgetVersionPage(
    widgetId: string,
    getWidgetVersionPageForm: IGetWidgetVersionPageForm
  ): Promise<IPage<IWidgetVersion>> {
    const endpointUrl: string = super.getEndpointUrl( HostUtil.getApplicationApiEndpointUrl(), `v1/widget/${ widgetId }/version/page` );

    const defaultSort: ISort = {
      field: "versionNumber",
      ascending: true
    };

    return firstValueFrom( this._httpClient.get( endpointUrl, {
      withCredentials: true,
      params: {
        pageNumber: getWidgetVersionPageForm.pageNumber,
        pageSize: getWidgetVersionPageForm.pageSize,
        sort: super.serializeSort( defaultSort )
      }
    } ) as Observable<IPage<IWidgetVersion>> );
  }
}
